module.exports = __webpack_public_path__ + "static/media/front-direct-image-1-mobile.da015310.jpg";